import Http from './../http';

const prefix = '/external_directory';
const env = { env: (process.env.NODE_ENV === 'development') ? 'development' : ''};

export const getUserFiles = (module_name = 'Images') => {
  let data = { module : module_name };
  return Http.authApi().post(`${prefix}/load-user`, data);
};

export const getSystemFiles = (type_system = '') => {
  // let data = { modules : type_system ? type_system : ['Images','Icons','Buttons','Gifs']}
    let data = { modules : type_system ? type_system : 'Images'};
  return Http.authApi().post(`${prefix}/load-system`, data);
};

export const getAll = (module_name = 'Images') => {
  return Http.authApi().get(`${prefix}?type_module=${module_name}`);
};

export const create = directory => {
  if(env)
    directory = {...directory, ...env};
  return Http.authApi().post(`${prefix}`, directory);
};

export const edit = directory => {
  return Http.authApi().put(`${prefix}/${directory.id}`, directory);
};

export const exclude = directory => {
  return Http.authApi().delete(`${prefix}/${directory.id}`, { data: directory });
};



// WEBPACK FOOTER //
// ./src/js/services/files/directory.js